<mat-card [appearance]="configData.cardAppearanceType"
          [ngClass]="{ 'card--grey': configData.backgroundColorType === BgColorType.Grey }">
  <mat-card-header *ngIf="title || configData.isEditable"
                   class="card-header">
    <mat-card-title [class.mat-card-title-sm]="configData.titleSize === TitleSize.Small"
                    [class.mat-card-title-xs]="configData.titleSize === TitleSize.ExtraSmall">
      {{title}}
    </mat-card-title>
    <button *ngIf="configData.isEditable"
            (click)="onClickEdit()"
            mat-icon-button
            aria-label="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding"
                    [class.no-header]="!title && !configData.isEditable">
    <ifc-horizontal-list [items]="listItems"></ifc-horizontal-list>
  </mat-card-content>
</mat-card>
